/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint esversion: 9 */
/* jshint ignore:start */
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import ArrowUp from "../Icon/arrow-up.svg";
import ArrowDown from "../Icon/arrow-down.svg";
import { FaStar } from "react-icons/fa";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { toast } from "react-toastify";
import CloseIcon from "../Icon/times.svg";
import { GoChevronDown } from "react-icons/go";
import { Link, useLocation } from "react-router-dom";
import { MyContext } from "../Context/MyProvider";
import axios from "axios";
import Payment from "../PaymentMethod/Payment";
import { useTranslation } from "react-i18next";
import { showTost } from "../showTost";
import CoinInfo from "../images/icons/buy-coin-point.png";
import PackageIcon from "../images/icons/buycoin-package.png";
import PageHeader from "./PageHeader";
import { FiDisc } from "react-icons/fi";
import LodingLottie from "../Lodinglottie";
const BuyCoin = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const {
    basUrl,
    toggleButton,
    setToggleButton,
    setPageName,
    buyCoin,
    walletCoin,
    setBuyCoin,
    currency,
    setWalletCoin,
    setAmount,
  } = useContext(MyContext);

  const [select, setSelect] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [isVisible2, setIsVisible2] = useState(false);
  const [input, setInput] = useState();
  const [coin, setCoin] = useState();
  const [selectType, setSelectType] = useState("");
  const [upi, setUpi] = useState();
  const [accountNumber, setAccountnumber] = useState();
  const [bankName, setBankName] = useState();
  const [accountName, setAccountName] = useState();
  const [ifsc, setIfsc] = useState();
  const [email, setEmail] = useState();
  const [index, setIndex] = useState();
  const [coiPackage, setCoinPackage] = useState([]);
  const [youCoin, setYouCoin] = useState();
  const [withdrawalLength, setWithdrawaLength] = useState();
  const hostedReturnProcessedRef = useRef(false);
  const legacyPaymentDoneProcessedRef = useRef(false);

  useEffect(() => {
    setCoin((parseInt(input) * 0.02).toFixed(2));
  }, [input]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("withdraw") === "1") {
      setIsVisible(true);
    }
  }, [location.search]);

  const TopUpHandler = (e) => {
    if (select) {
      setToggleButton(true);
      setPageName("BuyCoin");
      localStorage.setItem("PackageId", select);
    } else {
      showTost({ title: "Please Select Coin Package" });
    }
  };

  const toggleBottomSheet = (e) => {
    if (e === "Withdraw") {
      setIsVisible(false);
    } else {
      setIsVisible(true);
    }
  };

  const SelectHandler = (el) => {
    setSelectType(el);
    setIsVisible2(!isVisible2);
  };

  const ProceedHandler = () => {
    if (input) {
      if (input < withdrawalLength) {
        showTost({
          title: `Minimum ${withdrawalLength} coins a withdrawal !!`,
        });
        return;
      }

      if (selectType) {
        if (selectType === "UPI") {
          if (upi) {
            withdrawHandler();
          } else {
            setIndex(2);
          }
        } else if (selectType === "BANK Transfer") {
          if (accountNumber && bankName && accountName && ifsc) {
            withdrawHandler();
          } else {
            setIndex(3);
          }
        } else if (selectType === "Paypal") {
          if (email) {
            withdrawHandler();
          } else {
            setIndex(4);
          }
        }
      } else {
        showTost({ title: "Please Select Type" });
      }
    } else {
      setIndex(1);
    }
  };

  const withdrawHandler = () => {
    const localData = localStorage.getItem("Register_User");

    if (localData) {
      const userData = JSON.parse(localData);
      axios
        .post(`${basUrl}request_withdraw`, {
          uid: userData.id,
          coin: input,
          r_type: selectType,
          acc_number: accountNumber ? accountNumber : "",
          bank_name: bankName ? bankName : "",
          ifsc_code: ifsc ? ifsc : "",
          acc_name: accountName ? accountName : "",
          upi_id: upi ? upi : "",
          paypal_id: email ? email : "",
          coin_amt: coin,
        })
        .then((res) => {
          if (res.data.Result === "true") {
            CoinHandler();
            FildClearHandler();
            showTost({ title: res.data.ResponseMsg });
          } else {
            showTost({
              title: `Plaese Enter Minimum ${withdrawalLength} Coin !!`,
            });
          }
        });
    }
  };

  const FildClearHandler = () => {
    toggleBottomSheet("Withdraw");
    setSelectType("");
    setInput("");
    setCoin("");
    setUpi("");
    setAccountnumber("");
    setBankName("");
    setAccountName("");
    setIfsc("");
    setEmail("");
  };

  const CoinHandler = useCallback(() => {
    const localData = localStorage.getItem("Register_User");

    if (localData) {
      const userData = JSON.parse(localData);
      axios
        .post(`${basUrl}coin_report`, { uid: userData.id })
        .then((res) => {
          setYouCoin(res.data.coin);
          setWithdrawaLength(res.data.coin_limit);
        });
    }
  }, [basUrl]);

  useEffect(() => {
    const handleGiftBalanceRefresh = () => CoinHandler();
    window.addEventListener("gomeet:gift-sent", handleGiftBalanceRefresh);
    window.addEventListener("gomeet:gift-received", handleGiftBalanceRefresh);

    return () => {
      window.removeEventListener("gomeet:gift-sent", handleGiftBalanceRefresh);
      window.removeEventListener("gomeet:gift-received", handleGiftBalanceRefresh);
    };
  }, [CoinHandler]);

  const verifyHostedCoinReturn = useCallback((params, gatewayName) => {
    const localData = localStorage.getItem("Register_User");
    const storageKey = `${gatewayName}PendingPayment`;
    const pendingData = localStorage.getItem(storageKey);
    let pending = {};

    if (!localData) {
      showTost({ title: "Login required to verify payment." });
      return;
    }

    if (pendingData) {
      try {
        pending = JSON.parse(pendingData);
      } catch (err) {
        pending = {};
      }
    }

    if (pending.item_type && pending.item_type !== "package") {
      return;
    }

    const orderId = params.get("order_id") || pending.order_id;
    const gatewayReference = gatewayName === "Stripe"
      ? params.get("stripe_session_id") || pending.gateway_order_id
      : gatewayName === "PayStack"
        ? params.get("reference") || params.get("trxref") || pending.gateway_order_id
        : gatewayName === "FlutterWave"
          ? params.get("tx_ref") || pending.gateway_order_id
          : gatewayName === "MercadoPago"
            ? params.get("preference_id") || pending.gateway_order_id
            : gatewayName === "Khalti"
              ? params.get("pidx") || pending.pidx || pending.gateway_order_id
            : gatewayName === "Instamojo"
              ? params.get("payment_request_id") || params.get("payment_request") || pending.payment_request_id || pending.gateway_order_id
            : params.get("order_id") || pending.gateway_order_id;
    const gatewayTransactionId = params.get("transaction_id");
    const mercadoPagoPaymentId = params.get("payment_id") || params.get("collection_id");
    const instamojoPaymentId = params.get("payment_id") || params.get("payment");
    const tapChargeId = params.get("tap_charge_id") || params.get("charge_id") || params.get("id") || pending.tap_charge_id;
    const paydunyaToken = params.get("token") || params.get("invoice_token") || pending.invoice_token;
    const molliePaymentId = params.get("id") || params.get("payment_id") || pending.mollie_payment_id;
    const bkashPaymentId = params.get("paymentID") || params.get("payment_id") || pending.bkash_payment_id;

    if (!orderId || !gatewayReference) {
      showTost({ title: `${gatewayName} order details missing. Please retry payment.` });
      return;
    }

    const userData = JSON.parse(localData);
    axios.post(`${basUrl}verify_payment`, {
      uid: userData.id,
      order_id: orderId,
      stripe_session_id: gatewayName === "Stripe" ? gatewayReference : undefined,
      paystack_reference: gatewayName === "PayStack" ? gatewayReference : undefined,
      reference: gatewayName === "PayStack" ? gatewayReference : undefined,
      flutterwave_transaction_id: gatewayName === "FlutterWave" ? gatewayTransactionId : undefined,
      transaction_id: gatewayName === "FlutterWave" ? gatewayTransactionId : undefined,
      tx_ref: gatewayName === "FlutterWave" ? gatewayReference : undefined,
      collection_id: gatewayName === "MercadoPago" ? mercadoPagoPaymentId : undefined,
      preference_id: gatewayName === "MercadoPago" ? gatewayReference : undefined,
      pidx: gatewayName === "Khalti" ? gatewayReference : undefined,
      payment_request_id: gatewayName === "Instamojo" ? gatewayReference : undefined,
      payment_id: gatewayName === "Instamojo" ? instamojoPaymentId : (gatewayName === "MercadoPago" ? mercadoPagoPaymentId : undefined),
      tap_charge_id: gatewayName === "Tap" ? tapChargeId || gatewayReference : undefined,
      charge_id: gatewayName === "Tap" ? tapChargeId || gatewayReference : undefined,
      paydunya_token: gatewayName === "PayDunya" ? paydunyaToken || gatewayReference : undefined,
      invoice_token: gatewayName === "PayDunya" ? paydunyaToken || gatewayReference : undefined,
      mollie_payment_id: gatewayName === "Mollie" ? molliePaymentId || gatewayReference : undefined,
      bkash_payment_id: gatewayName === "bKash" ? bkashPaymentId || gatewayReference : undefined,
      paymentID: gatewayName === "bKash" ? bkashPaymentId || gatewayReference : undefined,
      gateway_order_id: gatewayReference,
    })
      .then((res) => {
        if (res.data.Result === "true" && res.data.status === "granted") {
          showTost({ title: "Payment verified successfully." });
          localStorage.removeItem(storageKey);
          CoinHandler();
          setSelect("");
          setWalletCoin("");
          setAmount("");
          setBuyCoin("");
          setToggleButton(false);
          localStorage.setItem("PaymentDone", "");
          localStorage.setItem("PackageId", "");
          window.history.replaceState({}, document.title, window.location.pathname);
        } else {
          showTost({ title: res.data.ResponseMsg || `${gatewayName} payment verification pending.` });
        }
      })
      .catch(() => {
        showTost({ title: `Unable to verify ${gatewayName} payment.` });
      });
  }, [basUrl, CoinHandler, setAmount, setBuyCoin, setToggleButton, setWalletCoin]);

  const PackageHandler = useCallback(() => {
    const localData = localStorage.getItem("Register_User");
    const PackgeId = localStorage.getItem("PackageId");

    if (localData) {
      const userData = JSON.parse(localData);
      axios
        .post(`${basUrl}package_purchase`, {
          uid: userData.id,
          package_id: PackgeId ? PackgeId : select,
          wall_amt: walletCoin ? walletCoin : "0",
        })
        .then((res) => {
          if (res.data.Result === "true") {
            toast(`💞 ${res.data.ResponseMsg}`, {
              position: "top-center",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              theme: "dark",
              className: "toast-Style",
            });
            CoinHandler();
            setSelect("");
            setWalletCoin("");
            setAmount("");
            setBuyCoin("");
            setToggleButton(false);
            localStorage.setItem("PaymentDone", "");
            localStorage.setItem("PackageId", "");
          }
        });
    }
  }, [basUrl, select, walletCoin, CoinHandler, setAmount, setBuyCoin, setToggleButton, setWalletCoin]);

  useEffect(() => {
    axios.post(`${basUrl}list_package`).then((res) => {
      setCoinPackage(res.data.packlist);
    });
  }, [basUrl]);

  useEffect(() => {
    CoinHandler();
  }, [CoinHandler]);

  useEffect(() => {
    if (legacyPaymentDoneProcessedRef.current) return;

    const done = localStorage.getItem("PaymentDone");
    if (done === "PaymentDoneCoin") {
      legacyPaymentDoneProcessedRef.current = true;
      PackageHandler();
      localStorage.setItem("PaymentDone", "");
    }
  }, [PackageHandler]);

  useEffect(() => {
    if (hostedReturnProcessedRef.current) return;

    const params = new URLSearchParams(window.location.search);
    const gateway = params.get("payment_gateway") || params.get("gateway");
    const paymentStatus = params.get("payment_status");
    const hostedGateways = [
      "Stripe",
      "PayStack",
      "FlutterWave",
      "Payfast",
      "Midtrans",
      "2checkout",
      "2Checkout",
      "MercadoPago",
      "Khalti",
      "Khalti Payment",
      "Cashfree",
      "SSLCommerz",
      "Instamojo",
      "Tap",
      "PerfectMoney",
      "PayDunya",
      "Mollie",
      "bKash",
    ];

    if (!hostedGateways.includes(gateway)) return;

    hostedReturnProcessedRef.current = true;

    if (paymentStatus === "success") {
      const normalizedGateway =
        gateway === "2Checkout" ? "2checkout" : gateway === "Khalti Payment" ? "Khalti" : gateway;
      verifyHostedCoinReturn(params, normalizedGateway);
    } else if (paymentStatus === "cancelled") {
      showTost({ title: "Payment cancelled." });
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, [verifyHostedCoinReturn]);

  useEffect(() => {
    if (!buyCoin) return;

    if (buyCoin === "PaymentDone") {
      PackageHandler();
    } else if (buyCoin === "PaymentVerified") {
      showTost({ title: "Payment verified successfully." });
      CoinHandler();
      setSelect("");
      setWalletCoin("");
      setAmount("");
      setBuyCoin("");
      setToggleButton(false);
      localStorage.setItem("PaymentDone", "");
      localStorage.setItem("PackageId", "");
    } else {
      showTost({ title: "Payment Failed..!!" });
      setSelect("");
      setToggleButton(false);
      setBuyCoin("");
    }
  }, [buyCoin, PackageHandler, CoinHandler, setAmount, setBuyCoin, setToggleButton, setWalletCoin]);

  const InputHandler = (e) => {
    const value = e.target.value;
    setInput(value);
    if (Number(value) > youCoin) {
      setInput("");
      showTost({ title: "Please Enter Your Currect Coin!" });
    }
  };

  return (
    <div className="main-wrapper bg-[#e5e5e5] dashboard">
      <div className="content-body">
        <div className="container-fluid my-2 sm:my-4 px-2.5 sm:px-4">
          <PageHeader
            title={t("Coin Wallet")}
            subtitle={t("Purchase coins for sending virtual gifts and unlocking features")}
            breadcrumbs={[{ label: t("Buy Coin") }]}
            icon={FiDisc}
            actions={
              <div className="flex items-center gap-3">
                <div className="flex items-center gap-2 bg-purple-50 border border-purple-200 px-3.5 py-1.5 rounded-xl shadow-xs">
                  <img src={PackageIcon} className="w-[20px] h-[20px] object-contain" alt={t("coins")} />
                  <span className="text-base font-bold text-purple-900">{youCoin ? youCoin : "0"} {t("Coins")}</span>
                </div>
                <Link
                  to="/history"
                  className="flex items-center gap-2 bg-purple-600 hover:bg-purple-700 text-white font-semibold px-4 py-2 rounded-xl transition-all shadow-xs cursor-pointer text-sm"
                >
                  <span>{t("History")}</span>
                </Link>
              </div>
            }
          />

          <div className="bg-white p-[30px] max-_430_:p-[16px] rounded-[15px] border border-gray-200/80 mb-[16px]">
            <h6 className="font-semibold text-lg mb-3">{t("Select Coin Package")}</h6>
            <div className="mt-[20px] flex justify-center gap-[45px] max-_768_:gap-[15px] max-_768_:justify-evenly scroll-container2 py-[10px]">
              {coiPackage.map((item, index) => {
                return (
                  <button
                    key={index}
                    onClick={() => setSelect(item.id)}
                    className={` ${
                      select === item.id
                        ? "border-[rgba(152,14,255,255)]"
                        : "border-gray-300"
                    } relative rounded-[15px] px-[25px] py-[20px] border-[2px]`}
                  >
                    {select === item.id && (
                      <div className="absolute -top-[10px] -right-[10px] bg-[rgba(152,14,255,255)] text-white w-[24px] h-[24px] rounded-full flex items-center justify-center text-xs font-bold shadow-xs z-10">
                        ✓
                      </div>
                    )}
                    <h2 className="m-0 text-[18px] flex items-center justify-center gap-[6px]">
                      <img
                        src={PackageIcon}
                        className="w-[18px] h-[18px] object-contain"
                        alt={t("coins")}
                      />
                      {item.coin}
                    </h2>
                    <h6 className="mb-0 mt-[10px]">
                      {currency ? currency : "$"}
                      {item.amt}
                    </h6>
                  </button>
                );
              })}
            </div>
            <div className="flex flex-wrap justify-center gap-[40px] max-_430_:gap-[15px] mt-[20px]">
              <button
                onClick={TopUpHandler}
                className="flex items-center gap-[10px] bg-[#980EFF] text-white rounded-full ps-[8px] pe-[15px] py-[5px]"
              >
                <img
                  src={ArrowUp}
                  alt=""
                  className="bg-white rounded-full p-[7px] w-[30px] h-[30px]"
                />
                <h6 className="mt-[8px]">{t("Top-up")}</h6>
              </button>
              <button
                onClick={toggleBottomSheet}
                className="flex items-center gap-[10px] bg-[#980EFF] text-white rounded-full ps-[8px] pe-[15px] py-[5px]"
              >
                <img
                  src={ArrowDown}
                  alt=""
                  className="bg-white rounded-full p-[7px] w-[30px] h-[30px]"
                />
                <h6 className="mt-[8px]">{t("Withdraw")}</h6>
              </button>
            </div>
          </div>

          <div className="bg-white p-[30px] max-_430_:p-[16px] rounded-[15px] border border-gray-200/80">
            <h5 className="font-[600]">{t("Coin Buying & Info")}</h5>
            <div className="mt-[20px]">
              <div className="flex items-center gap-[15px]">
                <img src={CoinInfo} style={{ width: "20px" }} alt="" />
                <h2 className="m-0 text-[18px] max-_430_:text-[16px] font-[400] text-gray-500 flex items-center gap-[5px]">
                  {t("Coin can be used for sending gifts only...")}
                </h2>
              </div>
              <div className="flex items-center gap-[15px] mt-[15px]">
                <img src={CoinInfo} style={{ width: "20px" }} alt="" />
                <h2 className="m-0 text-[18px] max-_430_:text-[16px] font-[400] text-gray-500 flex items-center gap-[5px]">
                  {t("Coins don't have any expiry date...")}
                </h2>
              </div>
              <div className="flex items-center gap-[15px] mt-[15px]">
                <img src={CoinInfo} style={{ width: "20px" }} alt="" />
                <h2 className="m-0 text-[18px] max-_430_:text-[16px] font-[400] text-gray-500 flex items-center gap-[5px]">
                  {t("Coins can be used with all payment modes...")}
                </h2>
              </div>
              <div className="flex items-center gap-[15px] mt-[15px]">
                <img src={CoinInfo} style={{ width: "20px" }} alt="" />
                <h2 className="m-0 text-[18px] max-_430_:text-[16px] font-[400] text-gray-500 flex items-center gap-[5px]">
                  {t("Coins are credited to your Coin balance only...")}
                </h2>
              </div>
              <div className="flex items-center gap-[15px] mt-[15px]">
                <img src={CoinInfo} style={{ width: "20px" }} alt="" />
                <h2 className="m-0 text-[18px] max-_430_:text-[16px] font-[400] text-gray-500 flex items-center gap-[5px]">
                  {t(
                    "Coins can be withdrawn with the described method only...",
                  )}
                </h2>
              </div>
              <div className="flex items-center gap-[15px] mt-[15px]">
                <img src={CoinInfo} style={{ width: "20px" }} alt="" />
                <h2 className="m-0 text-[18px] max-_430_:text-[16px] font-[400] text-gray-500 flex items-center gap-[5px]">
                  {t("Coins cannot be transferred to any users...")}
                </h2>
              </div>
              <div className="flex items-center gap-[15px] mt-[15px]">
                <img src={CoinInfo} style={{ width: "20px" }} alt="" />
                <h2 className="m-0 text-[18px] max-_430_:text-[16px] font-[400] text-gray-500 flex items-center gap-[5px]">
                  {t(
                    `You need a minimum of ${withdrawalLength} coins to make a withdrawal...`,
                  )}
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isVisible && (
        <div
          onClick={() => toggleBottomSheet("Withdraw")}
          className="bottom-sheet2 z-[9999] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bottom-sheet-content2 relative"
          >
            <div className="flex items-center justify-between">
              <h2 className="m-0 text-[20px] flex items-center gap-[5px]">
                <FaStar className="bg-[rgba(152,14,255,255)] w-[30px] h-[30px] text-white rounded-full p-[5px]" />{" "}
                1 coin = {currency ? currency : "$"}0.02
              </h2>
              <button onClick={FildClearHandler}>
                <img src={CloseIcon} alt="" />
              </button>
            </div>
            <div className="mt-[20px]">
              <input
                value={input}
                onChange={(e) => InputHandler(e)}
                type="number"
                className={`border-[2px] w-[100%] ${index === 1 ? (input ? "outline-[rgba(152,14,255,255)]" : "border-red-500 outline-none") : "border-gray-300 outline-[rgba(152,14,255,255)]"}  rounded-[10px] px-[15px] py-[8px]`}
                placeholder={t("Number Of Coin")}
              />
              {index === 1 && !input && (
                <span className="font-[400] text-red-500 block mt-1">
                  {t("Please Enter Amount")}
                </span>
              )}
              {input && (
                <span className="text-[16px] pt-[5px] block">
                  {currency ? currency : "$"}
                  {coin}
                </span>
              )}
            </div>
            <div className="">
              <h6 className="text-[16px] mt-[10px]">{t("Select Type")}</h6>
              <button
                onClick={() => setIsVisible2(!isVisible2)}
                className="w-[100%] flex justify-between items-center border-[2px] border-gray-300 rounded-[10px] px-[15px] py-[8px]"
              >
                <span>{selectType ? t(selectType) : t("Select Type")}</span>
                <GoChevronDown />
              </button>
            </div>

            {selectType === "UPI" ? (
              <div className="">
                <h6 className="text-[16px] mt-[10px]">{t("UPI")}</h6>
                <input
                  type="text"
                  onChange={(e) => setUpi(e.target.value)}
                  className={`border-[2px] w-[100%] ${index === 2 ? (upi ? "outline-[rgba(152,14,255,255)]" : "border-red-500 outline-none") : "border-gray-300 outline-[rgba(152,14,255,255)]"}  rounded-[10px] px-[15px] py-[8px]`}
                  placeholder={t("UPI")}
                />
                {index === 2 && !upi && (
                  <span className="font-[400] text-red-500">
                    {t("Please Enter UPI")}
                  </span>
                )}
              </div>
            ) : selectType === "BANK Transfer" ? (
              <div className="">
                <div className="">
                  <h6 className="text-[16px] mt-[10px]">
                    {t("Account Number")}
                  </h6>
                  <input
                    type="text"
                    className={`border-[2px] w-[100%] ${index === 3 ? (accountNumber ? "outline-[rgba(152,14,255,255)]" : "border-red-500 outline-none") : "border-gray-300 outline-[rgba(152,14,255,255)]"}  rounded-[10px] px-[15px] py-[8px]`}
                    placeholder={t("Account Number")}
                    onChange={(e) => setAccountnumber(e.target.value)}
                  />
                  {index === 3 && !accountNumber && (
                    <span className="font-[400] text-red-500">
                      {t("Please Enter Account Number")}
                    </span>
                  )}
                </div>

                <div className="">
                  <h6 className="text-[16px] mt-[10px]">{t("Bank Name")}</h6>
                  <input
                    type="text"
                    className={`border-[2px] w-[100%] ${index === 3 ? (bankName ? "outline-[rgba(152,14,255,255)]" : "border-red-500 outline-none") : "border-gray-300 outline-[rgba(152,14,255,255)]"}  rounded-[10px] px-[15px] py-[8px]`}
                    placeholder={t("Bank Name")}
                    onChange={(e) => setBankName(e.target.value)}
                  />
                  {index === 3 && !bankName && (
                    <span className="font-[400] text-red-500">
                      {t("Please Enter Bank Name")}
                    </span>
                  )}
                </div>
                <div className="">
                  <h6 className="text-[16px] mt-[10px]">
                    {t("Account Holder Name")}
                  </h6>
                  <input
                    type="text"
                    className={`border-[2px] w-[100%] ${index === 3 ? (accountName ? "outline-[rgba(152,14,255,255)]" : "border-red-500 outline-none") : "border-gray-300 outline-[rgba(152,14,255,255)]"}  rounded-[10px] px-[15px] py-[8px]`}
                    placeholder={t("Account Holder Name")}
                    onChange={(e) => setAccountName(e.target.value)}
                  />
                  {index === 3 && !accountName && (
                    <span className="font-[400] text-red-500">
                      {t("Please Enter Account Holder Name")}
                    </span>
                  )}
                </div>
                <div className="">
                  <h6 className="text-[16px] mt-[10px]">{t("IFSC Code")}</h6>
                  <input
                    type="text"
                    className={`border-[2px] w-[100%] ${index === 3 ? (ifsc ? "outline-[rgba(152,14,255,255)]" : "border-red-500 outline-none") : "border-gray-300 outline-[rgba(152,14,255,255)]"}  rounded-[10px] px-[15px] py-[8px]`}
                    placeholder={t("IFSC Code")}
                    onChange={(e) => setIfsc(e.target.value)}
                  />
                  {index === 3 && !ifsc && (
                    <span className="font-[400] text-red-500">
                      {t("Please Enter IFSC Code")}
                    </span>
                  )}
                </div>
              </div>
            ) : selectType === "Paypal" ? (
              <div className="">
                <h6 className="text-[16px] mt-[10px]">{t("Email ID")}</h6>
                <input
                  type="text"
                  className={`border-[2px] w-[100%] ${index === 4 ? (email ? "outline-[rgba(152,14,255,255)]" : "border-red-500 outline-none") : "border-gray-300 outline-[rgba(152,14,255,255)]"}  rounded-[10px] px-[15px] py-[8px]`}
                  placeholder={t("Email ID")}
                  onChange={(e) => setEmail(e.target.value)}
                />
                {index === 4 && !email && (
                  <span className="font-[400] text-red-500">
                    {t("Please Email ID")}
                  </span>
                )}
              </div>
            ) : (
              ""
            )}

            <div className="mt-[20px] justify-center flex gap-[30px]">
              <button
                onClick={FildClearHandler}
                className="py-[10px] px-[25px] font-[500]"
              >
                {t("Cancel")}
              </button>
              <button
                onClick={ProceedHandler}
                className="bg-[rgb(152,14,255)] text-white py-[10px] px-[25px] rounded-full"
              >
                {t("Proceed")}
              </button>
            </div>

            {isVisible2 && (
              <div
                onClick={() => setIsVisible2(!isVisible2)}
                className="h-[100%] w-[100%]  absolute top-0 left-0"
              >
                <div className="w-[90%] border-[2px] font-[500] bg-white border-gray-300 rounded-[10px] px-[15px] py-[8px] absolute top-[80px] left-[20px]">
                  <h6
                    onClick={() => SelectHandler("UPI")}
                    className="cursor-pointer py-[2px]"
                  >
                    {t("UPI")}
                  </h6>
                  <h6
                    onClick={() => SelectHandler("BANK Transfer")}
                    className="cursor-pointer py-[2px]"
                  >
                    {t("BANK Transfer")}
                  </h6>
                  <h6
                    onClick={() => SelectHandler("Paypal")}
                    className="cursor-pointer py-[2px]"
                  >
                    {t("Paypal")}
                  </h6>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ========= Payment Method ========== */}
      {toggleButton && <Payment Amount={coiPackage.find((item) => item.id === select)?.amt} ItemType="package" ItemId={select} />}

      {coiPackage.length === 0 && (
        <div className="w-[100%] h-[100vh] ms-[8rem] max-_991_:ms-0 bg-white fixed flex items-center justify-center top-0 left-0 right-0 bottom-0 z-[555]">
          <LodingLottie
            ClassCss={
              "w-[20%] max-_430_:w-[100%] max-_770_:w-[50%] max-_1030_:w-[40%] max-_1145_:w-[30%] max-_1200_:w-[30%] max-_1300_:w-[30%]"
            }
          />
        </div>
      )}
    </div>
  );
};
export default BuyCoin;
/* jshint ignore:end */
